import "./App.css";
import React, { useLayoutEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import AppRouter from "./app/router";
import UpdateAvailableButton from "./components/UpdateAvailableButton";
import { AuthProvider } from "./shared/auth/AuthProvider";

function Wrapper({ children }) {
  const location = useLocation();

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  return children;
}

export default function App() {
  // default theme = dark
  // อนาคตสามารถเปลี่ยนเป็น state / localStorage / context ได้
  const themeClass = "theme-dark";

  return (
    <div className={`page-container ${themeClass}`}>
      <BrowserRouter>
        <AuthProvider>
          <Wrapper>
            <AppRouter />
          </Wrapper>
          <UpdateAvailableButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
